/* global dcAnalytics Handlebars createCookie */
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { load } from './keywordBloodhounds.js';
import { make } from './districtBloodhound.js';
import { convertKeywordsToFilter } from './convertKeywordsToFilter.js';
import { getURLParam } from '../adapters/dupes/queryParams.js';
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';
import './external-adapters/typeaheadJqueryAdapter.js';
import { buildHackySchoolPageUrl } from './buildHackySchoolPageUrl.js';

export const KeywordSearchBox = createReactClass({
    propTypes: {
        searchURL: PropTypes.string.isRequired,
        baseSearchURL: PropTypes.string.isRequired,
        callbacks: PropTypes.objectOf(PropTypes.func).isRequired,

        searchAll: PropTypes.func,
        filterCategories: PropTypes.array,
        extraFilters: PropTypes.array,
        placeholder: PropTypes.string,
        searchOnBlur: PropTypes.bool,
        // For parent components that need to be aware of the component's keyword state
        setPendingKeywords: PropTypes.func,
    },

    mixins: [PureRenderMixin],
    searchName: 'keyword',

    getDefaultProps: function () {
        return {
            placeholder: 'Search topics, teachers & schools',
        };
    },

    getInitialState: function () {
        return {
            keywords: this.extractKeywords(this.props),
        };
    },

    onBlur: function () {
        if (this.props.searchOnBlur) {
            this.submit();
        }
    },

    submit: function () {
        (this.props.searchAll || this.validateKeywordsForm)();
        if (this.props.setPendingKeywords) {
            this.props.setPendingKeywords('');
        }
        // Without this, keyword suggestions stayed open if you used enter to submit
        // a keyword that was converted into a discrete filter after submission
        // eslint-disable-next-line react/no-find-dom-node
        $(ReactDOM.findDOMNode(this)).typeahead('close');
    },

    /**
     * @param schoolsOnly whether to only search for schools
     * @param teachersOnly whether to only search for teachers
     */
    makeURL: function (schoolsOnly, teachersOnly) {
        const props = this.props;
        const keywords = this.state.keywords.replace(/<script>/i, '');

        if (keywords === this.extractKeywords(props)) {
            return props.searchURL;
        }

        dcAnalytics.track('Search', { Keyword: keywords });

        if (!schoolsOnly && !teachersOnly) {
            const filter = this.findCorrespondingFilter(keywords);
            if (filter) {
                const param = {};
                param[filter.paramName] = filter.value;
                return props.callbacks.makeSearchURL(param);
            }
        }

        const params = {
            keywords,
            widenRetry: null,
            schoolsOnly,
            teachersOnly,
        };
        return props.callbacks.makeSearchURL(params);
    },

    /**
     * @param schoolsOnly whether to only search for schools
     * @param teachersOnly whether to only search for teachers
     */
    validateKeywordsForm: function (schoolsOnly, teachersOnly) {
        this.props.callbacks.changeURL(this.makeURL(schoolsOnly, teachersOnly));
    },

    componentDidMount: function () {
        const props = this.props;
        const bloodhounds = load();

        // eslint-disable-next-line react/no-find-dom-node
        $(ReactDOM.findDOMNode(this)).typeahead({
            highlight: true,
            hint: false,
        }, {
            name: 'keywords',
            display: 'value',
            source: bloodhounds.keywords.ttAdapter(),
            templates: {
                suggestion: function (word) {
                    return "<div class='suggestion suggestion-primary keyword-suggestion'>" + word.value + '</div>';
                },
            },
        }, {
            name: 'teachers',
            display: function (item) { return item.teacherName ? (item.teacherName + ' - ' + item.schoolName + ', ' + item.cityName + ', ' + item.stateCode) : ''; },
            source: bloodhounds.teachers.ttAdapter(),
            templates: {
                suggestion: Handlebars.templates['teacherSuggestion.tmpl'],
                header: "<div class='separator'>Teachers</div>",
            },
        }, {
            name: 'schools',
            display: function (item) { return item.schoolName ? (item.schoolName + ' - ' + item.address1 + ', ' + item.cityName + ', ' + item.stateCode) : ''; },
            source: bloodhounds.schools.ttAdapter(),
            templates: {
                suggestion: Handlebars.templates['schoolSuggestion.tmpl'],
                header: "<div class='separator'>Schools</div>",
            },
        }, {
            name: 'districts',
            display: function (item) { return item.name + ', ' + item.stateCode; },
            source: make().ttAdapter(),
            templates: {
                header: "<div class='separator'>School districts</div>",
                suggestion: function (district) {
                    return "<div class='suggestion location-suggestion'>" +
                    district.name + ', ' + district.stateCode +
                 '</div>';
                },
            },
        }).on('typeahead:selected', function (event, suggestion, dataName) {
            if (dataName === 'schools') {
                if (suggestion.moreResults) {
                    this.validateKeywordsForm(true, null);
                } else {
                    window.location = buildHackySchoolPageUrl(suggestion.schoolId);
                }
            } else if (dataName === 'teachers') {
                if (suggestion.moreResults) {
                    this.validateKeywordsForm(null, true);
                } else {
                    createCookie('searchedForTeacher', suggestion.teacherId, 1);
                    window.location = baseURL + 'classroom/' + suggestion.teacherId;
                }
            } else if (dataName === 'districts') {
                this.setKeywords('');
                props.callbacks.applyFilters({
                    community: suggestion.districtId + ':2',
                });
            } else {
                if (dataName === 'keywords') {
                    this.setKeywords(suggestion.value, this.submit);
                } else {
                    this.submit();
                }
            }
        }.bind(this)).on('typeahead:autocompleted', function (event, suggestion, dataName) {
            if (dataName === 'keywords') {
                this.setKeywords(suggestion.value);
            }
        }.bind(this)).keypress(function (e) {
            if (e.keyCode === 13) {
                this.submit();
            }
        }.bind(this));
    },

    componentWillUnmount: function () {
        // eslint-disable-next-line react/no-find-dom-node
        $(ReactDOM.findDOMNode(this)).typeahead('destroy');
    },

    extractKeywords: function (props) {
        return getURLParam(props.searchURL, 'keywords') || '';
    },

    /**
    * @param {string} keywords
    * @returns {Object} A filter with the same text as the keyword search, if it exists
    */
    findCorrespondingFilter: function (keywords) {
        const filterCategories = (this.props.filterCategories || []).concat(this.props.extraFilters || []);
        return convertKeywordsToFilter(keywords, filterCategories);
    },

    UNSAFE_componentWillReceiveProps: function (nextProps) {
        // eslint-disable-next-line react/no-find-dom-node
        const node = $(ReactDOM.findDOMNode(this));
        const keywords = this.extractKeywords(nextProps);
        if (keywords !== this.extractKeywords(this.props)) {
            this.setState({ keywords });
            node.typeahead('val', keywords);
            node.typeahead('close');
        }
    },

    handleChange: function (event) {
        this.setKeywords(event.target.value.replace(/^\s+/, ''));
    },

    setKeywords: function (keywords, callback) {
        this.setState({
            keywords,
        }, callback);
        if (this.props.setPendingKeywords) {
            this.props.setPendingKeywords(keywords);
        }
    },

    render: function () {
        return (
            <input className="search-box"
                type="text" name="keywords"
                placeholder={this.props.placeholder} onBlur={this.onBlur}
                value={this.state.keywords} onChange={this.handleChange}
                aria-label="Keyword search: Suggestions appear below" />
        );
    },
});
